import PropTypes from 'prop-types';
import { createContext } from 'react';

import config from 'src/config';
import useLocalStorage from 'src/hooks/useLocalStorage';

// initial state
const initialState = {
	...config,
	onChangeContainer: () => {},
	onChangeLocalization: () => {},
	onChangeMode: () => {},
	onChangePresetColor: () => {},
	onChangeDirection: () => {},
	onChangeMiniDrawer: () => {},
	onChangeThemeLayout: () => {},
	onChangeMenuOrientation: () => {},
	onChangeFontFamily: () => {},
};

// ==============================|| CONFIG CONTEXT & PROVIDER ||============================== //

const ConfigContext = createContext(initialState);

function ConfigProvider({ children, isDev }) {
	const [config, setConfig] = useLocalStorage(
		'mantis-react-ts-config',
		initialState,
	);

	const onChangeContainer = () => {
		setConfig({
			...config,
			container: !config.container,
		});
	};

	const onChangeLocalization = (lang) => {
		setConfig({
			...config,
			i18n: lang,
		});
	};

	const onChangeMode = (mode) => {
		setConfig({
			...config,
			mode,
		});
	};

	const onChangePresetColor = (theme) => {
		setConfig({
			...config,
			presetColor: theme,
		});
	};

	const onChangeDirection = (direction) => {
		setConfig({
			...config,
			themeDirection: direction,
		});
	};

	const onChangeMiniDrawer = (miniDrawer) => {
		setConfig({
			...config,
			miniDrawer,
		});
	};

	const onChangeThemeLayout = (direction, miniDrawer) => {
		setConfig({
			...config,
			miniDrawer,
			themeDirection: direction,
		});
	};

	const onChangeMenuOrientation = (layout) => {
		setConfig({
			...config,
			menuOrientation: layout,
		});
	};

	const onChangeFontFamily = (fontFamily) => {
		setConfig({
			...config,
			fontFamily,
		});
	};

	return (
		<ConfigContext.Provider
			value={{
				...config,
				isDev,
				defaultMessages: {},
				onChangeContainer,
				onChangeLocalization,
				onChangeMode,
				onChangePresetColor,
				onChangeDirection,
				onChangeMiniDrawer,
				onChangeThemeLayout,
				onChangeMenuOrientation,
				onChangeFontFamily,
			}}
		>
			{children}
		</ConfigContext.Provider>
	);
}

export { ConfigProvider, ConfigContext };

ConfigProvider.propTypes = { children: PropTypes.node, isDev: PropTypes.bool };
